import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { studentRetrieveFundingRequests } from "./retrieve-funding-requests";
import type { StudentFundingRequestVM } from "@shared-kernel/application/ports/student/student-repository";

const initialState: RetrievalState<StudentFundingRequestVM[]> = { fetching: "idle", data: [] };

export const studentRetrieveFundingRequestsReducer = createReducer<RetrievalState<StudentFundingRequestVM[]>>(initialState, builder => {
  builder.addCase(studentRetrieveFundingRequests.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(studentRetrieveFundingRequests.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(studentRetrieveFundingRequests.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
